import 'rheostat/initialize';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Rheostat from 'rheostat';
import algorithm from '../helpers/sliderAlgorithm';
import getSteps from '../helpers/getSteps';
import { formatNumber } from '../../../../utils/helpers';
import 'rheostat/css/rheostat.css';

class InputSliders extends Component {
    state = {
        min: 0,
        max: this.props.maxAvailSqFt,
        selectedMin: 0,
        selectedMax: this.props.maxAvailSqFt,
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { filters } = nextProps;
        
        // @NOTE: Not sure about this logic and maybe will refactor in the future
        if (filters.availableSqFt) {
            if (filters.availableSqFt.value.min !== prevState.selectedMin || filters.availableSqFt.value.max !== prevState.selectedMax) {
                return {
                    selectedMin: filters.availableSqFt.value.min,
                    selectedMax: filters.availableSqFt.value.max,
                };
            }
        } else if (!filters.availableSqFt && prevState.selectedMin && prevState.selectedMax) {
            return {
                min: 0,
                max: nextProps.maxAvailSqFt,
                selectedMin: 0,
                selectedMax: nextProps.maxAvailSqFt,
            };
        } else if (!filters.availableSqFt && prevState.max !== nextProps.maxAvailSqFt) {
            return {
                max: nextProps.maxAvailSqFt,
            };
        }

        return {
            ...prevState,
        };
    }

    updateLocalValues = ({ values }) => {
        this.setState(() => ({
            min: values[0],
            max: values[1],
        }));
    }

    render() {
        const { filters, maxAvailSqFt, handleChange } = this.props;
        const { min, max } = this.state;
        const  steps = getSteps(0, maxAvailSqFt, 500);

        return (
            <div className="column">
                <p className="max-sq-ft">{(max >= 100000 ? '100,000+' : formatNumber(max))}</p>
                <Rheostat
                    algorithm={algorithm}
                    snap={true}
                    snapPoints={steps}
                    min={0}
                    max={(maxAvailSqFt)}
                    onChange={({ values }) => handleChange('availableSqFt', {
                        min: values[0],
                        max: values[1],
                    })}
                    onValuesUpdated={this.updateLocalValues}
                    values={(filters.availableSqFt) ? [ filters.availableSqFt.value.min, filters.availableSqFt.value.max ] : [ 1, maxAvailSqFt ]}
                />
                <p className="min-sq-ft">{(min <= 0 ? '0' : formatNumber(min))}</p>
            </div>
        );
    }
}

InputSliders.propTypes = {
    filters: PropTypes.object.isRequired,
    maxAvailSqFt: PropTypes.number.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default InputSliders;
